/**
 * [we] Ersatzteil-Finder — model selection, category filter, URL sync
 * Category chips are built in Liquid from each model's custom.ersatzteil_typ values.
 */
(function () {
  function initSection(root) {
    if (!root || root.dataset.finderReady === 'true') return;
    root.dataset.finderReady = 'true';

    const modelLabel = root.querySelector('[data-model-label]');
    const modelButtons = [...root.querySelectorAll('[data-model-select]')];
    const panels = [...root.querySelectorAll('[data-model-panel]')];
    const chipGroups = [...root.querySelectorAll('[data-model-chips]')];
    const chipsRoot = root.querySelector('[data-finder-chips]');
    const allChip = root.querySelector('[data-category-filter="all"]');
    const emptyEl = root.querySelector('[data-finder-empty]');

    function getModelFromUrl() {
      try {
        return new URLSearchParams(window.location.search).get('model') || '';
      } catch (e) {
        return '';
      }
    }

    function setModelInUrl(handle) {
      try {
        const url = new URL(window.location.href);
        if (handle) {
          url.searchParams.set('model', handle);
        } else {
          url.searchParams.delete('model');
        }
        window.history.replaceState({}, '', url.toString());
      } catch (e) {
        /* ignore */
      }
    }

    function getActivePanel() {
      return panels.find((panel) => !panel.hidden) || null;
    }

    function getActiveChipGroup() {
      return chipGroups.find((group) => !group.hidden) || null;
    }

    function getFilterChips() {
      const group = getActiveChipGroup();
      const groupChips = group ? [...group.querySelectorAll('[data-category-filter]')] : [];
      return allChip ? [allChip, ...groupChips] : groupChips;
    }

    function applyCategoryFilter(typKey) {
      const panel = getActivePanel();
      if (!panel) return;

      const parts = [...panel.querySelectorAll('[data-part-card]')];
      let visibleCount = 0;

      parts.forEach((part) => {
        const types = (part.dataset.typ || '')
          .trim()
          .split(/\s+/)
          .filter(Boolean);
        const show = !typKey || typKey === 'all' || types.indexOf(typKey) !== -1;
        part.hidden = !show;
        if (show) visibleCount += 1;
      });

      if (emptyEl) {
        emptyEl.hidden = visibleCount > 0;
      }
    }

    function setActiveChip(typKey) {
      getFilterChips().forEach((chip) => {
        const active = chip.dataset.categoryFilter === typKey;
        chip.classList.toggle('is-active', active);
        chip.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      applyCategoryFilter(typKey);
    }

    function selectModel(handle, { syncUrl = true } = {}) {
      let matched = false;

      modelButtons.forEach((btn) => {
        const active = btn.dataset.modelSelect === handle;
        btn.classList.toggle('is-selected', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
        if (active) {
          matched = true;
          if (modelLabel) {
            modelLabel.textContent = btn.dataset.modelTitle || btn.getAttribute('aria-label') || handle;
          }
        }
      });

      if (!matched && modelButtons.length) {
        const first = modelButtons[0];
        selectModel(first.dataset.modelSelect, { syncUrl });
        return;
      }

      panels.forEach((panel) => {
        panel.hidden = panel.dataset.modelPanel !== handle;
      });

      chipGroups.forEach((group) => {
        group.hidden = group.dataset.modelChips !== handle;
      });

      if (syncUrl) setModelInUrl(handle);

      // Reset category to "all" when changing model
      setActiveChip('all');
    }

    modelButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        selectModel(btn.dataset.modelSelect, { syncUrl: true });
      });
    });

    if (chipsRoot) {
      chipsRoot.addEventListener('click', (event) => {
        const chip = event.target.closest('[data-category-filter]');
        if (!chip || !chipsRoot.contains(chip)) return;
        setActiveChip(chip.dataset.categoryFilter || 'all');
      });
    }

    const urlModel = getModelFromUrl();
    const initial =
      (urlModel && modelButtons.some((b) => b.dataset.modelSelect === urlModel) && urlModel) ||
      (modelButtons[0] && modelButtons[0].dataset.modelSelect) ||
      '';

    if (initial) {
      selectModel(initial, { syncUrl: true });
    } else {
      setActiveChip('all');
    }
  }

  function boot() {
    document.querySelectorAll('[data-ersatzteil-finder]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target && event.target.querySelector
      ? event.target.querySelector('[data-ersatzteil-finder]')
      : null;
    if (root) {
      root.dataset.finderReady = 'false';
      initSection(root);
    }
  });
})();
